document.addEventListener("DOMContentLoaded", () => {
  const containers = document.querySelectorAll("[data-faq-container]");

  containers.forEach((container) => {
    const triggers = container.querySelectorAll(".faq-trigger");

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", function () {
        const item = this.closest(".faq-item");
        const expanded = this.getAttribute("aria-expanded") === "true";

        this.setAttribute("aria-expanded", !expanded);
        item.classList.toggle("is-open");
      });
    });
  });
});
